import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './translations/en/common.json';
import frCommon from './translations/fr/common.json';
import enStorage from './translations/en/storage.json';
import frStorage from './translations/fr/storage.json';
import enSummary from './translations/en/summary.json';
import frSummary from './translations/fr/summary.json';
import enPrince from './translations/en/prince.json';
import frPrince from './translations/fr/prince.json';
import enConversations from './translations/en/conversations.json';
import frConversations from './translations/fr/conversations.json';
import enPrompts from './translations/en/prompts.json';
import frPrompts from './translations/fr/prompts.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    storage: enStorage,
    summary: enSummary,
    prince: enPrince,
    conversations: enConversations,
    prompts: enPrompts,
  },
  fr: {
    common: frCommon,
    storage: frStorage,
    summary: frSummary,
    prince: frPrince,
    conversations: frConversations,
    prompts: frPrompts,
  },
} as const;

export type Translations = (typeof resources)['en'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: Object.keys(resources.en),
    defaultNS,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    pluralSeparator: '_',
    keySeparator: '.',
  });

export default i18n;
